<template>
  <v-card width="94%" height="96%" class="grey lighten-3" style="position: absolute">
    <v-row
      class="d-flex justify-space-between mx-2"
      v-for="(item, index) in anamRoute"
      :key="index"
    >
      <v-col cols="2" xs="2" sm="5" md="7" lg="8">
        <div class="d-flex mt-2 justify-start text-subtitle-1 font-weight-medium">
          {{ item.title }}
        </div>
        <span class="d-flex justify-star text-caption mt-n1" v-if="observerHCP === true">[ modo observador ]</span>
      </v-col>
      <v-col cols="10" xs="10" sm="7" md="5" lg="4" class="pa-0 mt-7">
        <v-form-base
          class="d-flex justify-end mt-1"
          :schema="schemaCoDate"
          :model="modelCoDate"
          @input="handleEvents"
        />
      </v-col>
    </v-row>
    <v-divider class="pb-0 mb-0 mt-2"></v-divider>
  </v-card>
</template>

<script>
import VFormBase from 'vuetify-form-base';

export default {
  name: 'VCardFormAnamCo',
  components: {
    VFormBase,
  },
  props: ['anamRoute', 'schemaCoDate', 'modelCoDate', 'handleEvents', 'observerHCP'],
  data() {
    return {
      campos: [
        {
          etiqueta: 'v-text-field',
          label: 'esto es una caja de texto',
          valor: 'Vuejs',
          type: 'text',
        },
      ],
    };
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
  },
  computed: {
    isRoute() {
      return this.$route.name === 'index';
    },
  },
};
</script>
